export default function (list, operation = 'and') {
  switch (list.size) {
    case 0:
      return '';
    case 1:
      return list.get(0);
    case 2:
      return list.join(` ${operation} `);
    default:
      return list.pop().join(', ') + `, ${operation} ` + list.last();
  }
}
